import {
    generateDefaultState,
    getActionTypes,
} from '../../../utils/reduxHelper';

export const actions = getActionTypes('dashboard', [
    'GET_STATS',
    'GET_PJO_STATS'
]);
export const initialDashboardStatsState = {
    ...generateDefaultState('dashboard', [
        'GET_STATS',
        'GET_PJO_STATS'
    ]),
};
